'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

const ReviewsHero = () => {
  const { language, t } = useLanguage();

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary to-secondary text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-white/20 px-4 py-2 rounded-full mb-6">
            <Icon name="StarIcon" size={20} variant="solid" className="text-accent" />
            <span className="text-sm font-body font-semibold">{t({ en: 'Verified Customer Reviews', ar: 'تقييمات عملاء موثقة' })}</span>
          </div>
          
          <h1 className="text-4xl lg:text-6xl font-headline font-bold mb-6">
            {t({ en: 'What Our Customers Say', ar: 'ماذا يقول عملاؤنا' })}
          </h1>
          
          <p className="text-lg lg:text-xl text-white/90 font-body mb-12">
            {t({ en: 'Real experiences from families and businesses who trusted Almanara with their moves across Kuwait.', ar: 'تجارب حقيقية من عائلات وشركات وثقت بالمنارة في عمليات النقل في جميع أنحاء الكويت.' })}
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="flex items-center justify-center space-x-1 mb-2">
                {[...Array(5)]?.map((_, index) => (
                  <Icon
                    key={index}
                    name="StarIcon"
                    size={24}
                    variant="solid"
                    className="text-accent"
                  />
                ))}
              </div>
              <div className="text-4xl font-headline font-bold mb-1">4.9</div>
              <div className="text-sm text-white/80 font-body">{t({ en: 'Average Rating', ar: 'متوسط التقييم' })}</div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <Icon name="UserGroupIcon" size={32} variant="solid" className="text-accent mx-auto mb-2" />
              <div className="text-4xl font-headline font-bold mb-1">2,847</div>
              <div className="text-sm text-white/80 font-body">{t({ en: 'Total Reviews', ar: 'إجمالي التقييمات' })}</div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <Icon name="CheckBadgeIcon" size={32} variant="solid" className="text-success mx-auto mb-2" />
              <div className="text-4xl font-headline font-bold mb-1">98%</div>
              <div className="text-sm text-white/80 font-body">{t({ en: 'Satisfaction Rate', ar: 'معدل الرضا' })}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewsHero;